import { Car } from 'lucide-react'

export function PlaceholderImage() {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-gray-700">
      <Car className="w-16 h-16 text-gray-400 dark:text-gray-500" />
    </div>
  )
}

